///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { PdbBandTypeEnum, PdbChannelFrequenciesEnum, ProductTypeEnum } from '../../../generated/shared-types.model';

export interface IProductFrequency {
    name: string;
    value: PdbChannelFrequenciesEnum;
    productTypes: ProductTypeEnum[];
    id?: number;
}

export class ProductBandTypes {
    // if change, add changes to PdbBandTypeEnum.java
    static readonly BAND_TYPES_MAP = new Map<PdbBandTypeEnum, { lowBound: number; topBound: number }>([
        [PdbBandTypeEnum.E_BAND, { lowBound: 70000, topBound: 79999 }],
        [PdbBandTypeEnum.V_BAND, { lowBound: 50000, topBound: 69999 }]
    ]);

    static frequencyInBound(frequency: IProductFrequency, bandName: PdbBandTypeEnum): boolean {
        const bandType = ProductBandTypes.BAND_TYPES_MAP.get(bandName);
        return frequency.value >= bandType.lowBound && frequency.value <= bandType.topBound;
    }
}

export class ProductFrequencies {
    // if change, add changes to PdbChannelFrequenciesEnum.java
    static readonly ALL_FREQUENCIES: IProductFrequency[] = [
        { value: PdbChannelFrequenciesEnum.F_57375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_58375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_58875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_59375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_59875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_60375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_62375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_62875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_63875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_64375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_65175_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_65675_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_66375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_66875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_71750_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_71875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_71937_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72000_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72062_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72125_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72187_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72250_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72312_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72437_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72500_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72562_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72687_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72750_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72812_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_72937_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73000_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73062_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73187_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73250_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73312_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73437_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73500_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73562_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73687_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73750_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73812_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_73937_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74000_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74062_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74187_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74250_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74312_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74437_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74500_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74562_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74625_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74687_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74750_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74812_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74875_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_74937_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75000_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75062_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75187_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75250_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75312_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75375_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75437_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75500_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75562_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75687_5, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75750_0, productTypes: [ProductTypeEnum.EH], name: null },
        { value: PdbChannelFrequenciesEnum.F_75812_5, productTypes: [ProductTypeEnum.EH], name: null },
        {
            value: PdbChannelFrequenciesEnum.F_58320_0,
            productTypes: [ProductTypeEnum.MH, ProductTypeEnum.TG_MH],
            name: 'channel-1 (58320)'
        },
        {
            value: PdbChannelFrequenciesEnum.F_60480_0,
            productTypes: [ProductTypeEnum.MH, ProductTypeEnum.TG_MH],
            name: 'channel-2 (60480)'
        },
        {
            value: PdbChannelFrequenciesEnum.F_62640_0,
            productTypes: [ProductTypeEnum.MH, ProductTypeEnum.TG_MH],
            name: 'channel-3 (62640)'
        },
        {
            value: PdbChannelFrequenciesEnum.F_64800_0,
            productTypes: [ProductTypeEnum.MH, ProductTypeEnum.TG_MH],
            name: 'channel-4 (64800)'
        }
    ];

    public static getProductFrequencyValues(productType: ProductTypeEnum, bandType?: PdbBandTypeEnum): IProductFrequency[] {
        return ProductFrequencies.ALL_FREQUENCIES.filter(
            (frequency: IProductFrequency) =>
                frequency.productTypes.indexOf(productType) !== -1 &&
                (productType !== ProductTypeEnum.EH ||
                    (bandType && ProductBandTypes.BAND_TYPES_MAP.has(bandType) && ProductBandTypes.frequencyInBound(frequency, bandType)))
        ).map((frequency: IProductFrequency) => {
            frequency.name = frequency.name ? frequency.name : frequency.value.toString();
            return frequency;
        });
    }

    public static getFrequencyChannelName(frequencyValue: number): string {
        let channel = '';
        ProductFrequencies.ALL_FREQUENCIES.forEach((frequency: IProductFrequency) => {
            if (frequency.value === frequencyValue) {
                channel = frequency.name ?? '';
            }
        });
        return channel;
    }
}
